// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  height: 100%;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0px;
  align-items: center;
}
.header-wrapper .back_btn {
  width: 20px;
  height: 20px;
}
.header-wrapper h3 {
  text-align: center;
}
.header-wrapper .add_fav_btn {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-wrapper .add_fav_btn.no-shadow {
  box-shadow: none;
}
.header-wrapper .add_fav_btn ion-icon {
  width: 25px;
  height: 25px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 25vh;
  width: 100%;
  margin: 0 auto 0px;
}

.default-img {
  height: 25vh;
  width: 100px !important;
}

.info {
  padding: 20px 20px 0px 20px;
}
.info .title {
  text-align: left;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-secondary);
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
}
.info .desc {
  text-align: left;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-primary);
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}

.usign-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0px;
}
.usign-block .using-item {
  width: 100%;
  display: flex;
  padding: 7px 10px;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  border-radius: 16px;
  margin-bottom: 10px;
  align-items: center;
}
.usign-block .using-item ion-icon {
  width: 15%;
}
.usign-block .using-item .type-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.usign-block .using-item .next-icon {
  width: 30px;
  height: 30px;
  margin-left: 10px;
}
.usign-block .using-item .text-block {
  width: 70%;
}
.usign-block .using-item .text-block h3,
.usign-block .using-item .text-block p {
  color: var(--ion-color-secondary);
  text-transform: inherit;
}
.usign-block .using-item .text-block h3 {
  font-size: 16px;
}
.usign-block .using-item .text-block p {
  font-size: 13px;
}

.info-text {
  text-align: center;
  padding: 5px 20px 20px;
  color: #c1c1c1;
  font-size: 12px;
}

.remove_btn {
  width: 100%;
  --background: var(--ion-color-danger);
}

.description {
  color: #899589;
  padding: 5px 0px;
  font-size: 16px !important;
}

.all-promo {
  display: flex;
  flex-direction: column;
}

.remove_btn {
  width: 100%;
  --background: var(--ion-color-danger);
  --color: white !important;
}
.remove_btn.add-btn {
  --background: var(--ion-color-primary) !important;
  --color: white !important;
}

.min-block {
  min-height: 70px;
  padding: 20px;
}

.all-promo {
  height: calc(100% - 270px);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/coupon-item-show-modal/coupon-item-show-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,YAAA;AAAD;;AAEA;EACC,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACD;;AACA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,mBAAA;AAED;AADC;EACC,WAAA;EACA,YAAA;AAGF;AADC;EACC,kBAAA;AAGF;AADC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,4DAAA;EAIA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AALE;EACC,gBAAA;AAOH;AAFE;EACC,WAAA;EACA,YAAA;AAIH;;AAAA;EACC,YAAA;EACA,cAAA;AAGD;;AAAA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AAGD;;AADA;EAEC,kBAAA;AAGD;AAFC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AAIF;AAFC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAIF;;AADA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAID;;AACA;EACC,YAAA;EACA,uBAAA;AAED;;AAAA;EACC,2BAAA;AAGD;AAFC;EACC,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AAIF;AAHE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;AAKH;AADC;EACC,gBAAA;EACA,2CAAA;EACA,gCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AAEF;AAAC;EACC,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAEF;AADE;EACC,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,iCAAA;AAEH;AAAE;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;AACH;AC7HE;EDmHA;IAWE,UAAA;IACA,iBAAA;EAGF;AACF;;AACA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAED;AADC;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,4DAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAGF;AAFE;EACC,UAAA;AAIH;AAFE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAIH;AAFE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAIH;AAFE;EACC,UAAA;AAIH;AAHG;;EAEC,iCAAA;EACA,uBAAA;AAKJ;AAHG;EACC,eAAA;AAKJ;AAHG;EACC,eAAA;AAKJ;;AAAA;EACC,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAGD;;AADA;EACC,WAAA;EACA,qCAAA;AAID;;AAFA;EACC,cAAA;EACA,gBAAA;EACA,0BAAA;AAKD;;AAHA;EACC,aAAA;EACA,sBAAA;AAMD;;AAJA;EACC,WAAA;EAEA,qCAAA;EACA,yBAAA;AAMD;AALC;EACC,iDAAA;EACA,yBAAA;AAOF;;AAJA;EACC,gBAAA;EACA,aAAA;AAOD;;AALA;EACC,0BAAA;EACA,cAAA;AAQD","sourcesContent":["@import '../../../theme/mixins';\n.wrapper {\n\theight: 100%;\n}\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n.header-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 20px 0px;\n\talign-items: center;\n\t.back_btn {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\th3 {\n\t\ttext-align: center;\n\t}\n\t.add_fav_btn {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tbackground: white;\n\t\tborder-radius: 50%;\n\t\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\t\t&.no-shadow {\n\t\t\tbox-shadow: none;\n\t\t}\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tion-icon {\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t}\n\t}\n}\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-img {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 30px;\n}\n.image-wrapper {\n\t// background: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n\tposition: relative;\n\t.back_icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 10px;\n\t\tz-index: 99;\n\t\tzoom: 1.5;\n\t}\n\t.cross_icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 10px;\n\t\tzoom: 1.5;\n\t}\n}\n.main-img {\n\theight: 25vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\t// &.full-width {\n\t//   object-fit: cover;\n\t// }\n}\n.default-img {\n\theight: 25vh;\n\twidth: 100px !important;\n}\n.info {\n\tpadding: 20px 20px 0px 20px;\n\t.title {\n\t\ttext-align: left;\n\t\tfont-size: 25px;\n\t\tline-height: var(--modal-info-title-line-height);\n\t\tmargin-bottom: 6px;\n\t\tpadding-top: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t\t.info_block {\n\t\t\tfont-size: 17px;\n\t\t\tmargin-left: 5px;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.desc {\n\t\ttext-align: left;\n\t\tfont-size: var(--modal-info-desc-font-size);\n\t\tfont-family: AppFont, sans-serif;\n\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding-bottom: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n\t.ingrediants-section {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tpadding: 10px 0px;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\th3 {\n\t\t\ttext-align: left;\n\t\t\tfont-size: 18px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tp {\n\t\t\tcursor: pointer;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\tline-height: var(--modal-info-desc-line-height);\n\t\t\tpadding-bottom: 10px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\t@include mobile {\n\t\t\t\twidth: 50%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n.usign-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tpadding: 10px 0px;\n\t.using-item {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tpadding: 7px 10px;\n\t\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\t\tborder-radius: 16px;\n\t\tmargin-bottom: 10px;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\twidth: 15%;\n\t\t}\n\t\t.type-icon {\n\t\t\twidth: 45px;\n\t\t\theight: 45px;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\t.next-icon {\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.text-block {\n\t\t\twidth: 70%;\n\t\t\th3,\n\t\t\tp {\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\ttext-transform: inherit;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-size: 16px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\t\t}\n\t}\n}\n.info-text {\n\ttext-align: center;\n\tpadding: 5px 20px 20px;\n\tcolor: #c1c1c1;\n\tfont-size: 12px;\n}\n.remove_btn {\n\twidth: 100%;\n\t--background: var(--ion-color-danger);\n}\n.description {\n\tcolor: #899589;\n\tpadding: 5px 0px;\n\tfont-size: 16px !important;\n}\n.all-promo {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n.remove_btn {\n\twidth: 100%;\n\n\t--background: var(--ion-color-danger);\n\t--color: white !important;\n\t&.add-btn {\n\t\t--background: var(--ion-color-primary) !important;\n\t\t--color: white !important;\n\t}\n}\n.min-block {\n\tmin-height: 70px;\n\tpadding: 20px;\n}\n.all-promo {\n\theight: calc(100% - 270px);\n\toverflow: auto;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
